import * as _ from "lodash-es";
import React, { Component } from "react";
import ICreateCategoryDTO from "../../../../models/DTO/ICreateCategoryDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCategoriesDTO from "../../../../models/DTO/IGetCategoriesDTO";
import IGetVendorSourcesDTO from "../../../../models/DTO/IGetVendorSourcesDTO";
import IOnCreateCategoryDTO from "../../../../models/DTO/IOnCreateCategoryDTO";
import IOnDeleteCategoryDTO from "../../../../models/DTO/IOnDeleteCategoryDTO";
import IOnGetCategoriesDTO from "../../../../models/DTO/IOnGetCategoriesDTO";
import IOnGetVendorSourcesDTO from "../../../../models/DTO/IOnGetVendorSourcesDTO";
import IOnReorderCategoriesDTO from "../../../../models/DTO/IOnReorderCategoriesDTO";
import IOnUpdateCategoryDTO from "../../../../models/DTO/IOnUpdateCategoryDTO";
import IReorderCategoriesDTO from "../../../../models/DTO/IReorderCategoriesDTO";
import IUpdateCategoryDTO from "../../../../models/DTO/IUpdateCategoryDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import ICategory from "../../../../models/ICategory";
import IVendor_Source_Location_Map_Item from "../../../../models/ICategory_Vendor_Source_Location_Map_Item";
import INewCategory from "../../../../models/INewCategory";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendor_Source from "../../../../models/IVendor_Source";
import IVendor_Source_Location from "../../../../models/IVendor_Source_Location";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import CategoryAccordion from "./CategoryAccordion/CategoryAccordion";
import "./CategorySidebar.scss";
import SortableCategoryList, { SortableCategoryItem } from "./SortableCategoryList/SortableCategoryList";
import { Socket } from "socket.io-client";
import { arrayMove } from "@dnd-kit/sortable";

type Props = {
    categories?: ICategory[];
    clearData?: any;
    cancel: any;
    saveFn: any;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    catalogModel?: ICatalog;
    priceGroups?: IPrice_Group[];
    isSimpleCategories?: boolean;
    isHomeCategories?: boolean;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    categories: ICategory[];
    disableSaveCategory?: boolean;
    activeSaveCategory?: boolean;
    allowAddCategory: boolean;
    vendorSources: IVendor_Source[];
};

class CategorySidebar extends Component<Props, State> {
    // Pre-drag order kept so we can revert if the server rejects a reorder
    private reorderSnapshot: ICategory[] | null = null;

    readonly state: State = {
        categories: this.props.categories || [],
        disableSaveCategory: false,
        activeSaveCategory: false,
        allowAddCategory: true, // this is used to track if the add button can be used - only allow one at a time adding
        vendorSources: [],
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.CategoriesOnGetCategories, this.onGetCategories);
        this.props.socket.on(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnDeleteCategory, this.onDeleteCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnReorderCategories, this.onReorderCategories);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSources, this.onGetVendorSources);

        this.getCategories();

        if (this.props.supplierModel.has_purchase_orders) {
            this.getVendorSources();
        }
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnGetCategories, this.onGetCategories);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnDeleteCategory, this.onDeleteCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnReorderCategories, this.onReorderCategories);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnGetVendorSources, this.onGetVendorSources);
    }

    getVendorSources = () => {
        const payload: IGetVendorSourcesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: 250,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSources, payload);
    };

    onGetVendorSources = (data: IOnGetVendorSourcesDTO) => {
        this.setState({
            vendorSources: data.vendorSources,
        });
    };

    getCategories = () => {
        const payload: IGetCategoriesDTO = {
            supplierGuid: this.props.supplierModel.guid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            onlyRootCategories: false,
        };

        if (this.props.catalogModel) {
            payload.catalogGuid = this.props.catalogModel.guid;
        } else {
            payload.isVendorCategory = true;
        }

        if (this.props.isHomeCategories) {
            payload.isHomeCategories = true;
        } else {
            payload.onlyRootCategories = true;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetCategories = (data: IOnGetCategoriesDTO) => {
        // A fresh server list supersedes any pending reorder revert
        this.reorderSnapshot = null;

        const categories = data.categories.map((category) => {
            if (!category.email) {
                category.email = "";
            }

            return category;
        });

        this.setState({
            categories,
        });
    };

    resetState = (callbackFn?: any) => {
        this.setState({}, () => {
            callbackFn();
            // this.forceUpdate();
        });
    };

    cancel = (e: any) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.resetState(this.props.cancel);
    };

    save = () => {
        this.props.saveFn(this.state.categories);
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    stubNewCategory = () => {
        const newCategory: INewCategory = {
            supplier_id: this.props.supplierModel.id,
            name: "",
        };

        if (this.props.catalogModel) {
            newCategory.catalog_id = this.props.catalogModel.id;
        } else {
            newCategory.is_vendor_category = true;
        }

        return newCategory;
    };

    addCategory = () => {
        const categories = this.state.categories;

        const state: any = {
            categories: [this.stubNewCategory(), ...categories],
            allowAddCategory: true,
        };

        this.setState(state);
    };

    cancelCategory = () => {
        const categories = this.state.categories;
        categories.shift();

        const state: any = {
            categories: [...categories],
            allowAddCategory: false,
        };

        this.setState(state);
    };

    createCategory = (newCategory: INewCategory, options?: { discounts?: number[] }) => {
        const payload: ICreateCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name: newCategory.name,
            note: newCategory.note,
        };

        if (this.props.catalogModel) {
            payload.catalogGuid = this.props.catalogModel.guid;
        } else {
            payload.isVendorCategory = true;
        }

        if (this.props.isHomeCategories) {
            payload.isHomeCategory = true;
        }

        if (options?.discounts) {
            payload.discounts = options.discounts;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesCreateCategory, payload);
    };

    processLocations = (categoryLocations: IVendor_Source_Location[]): IVendor_Source_Location_Map_Item[] => {
        const locations: IVendor_Source_Location_Map_Item[] = [];

        for (const location of categoryLocations) {
            const locationDetail: IVendor_Source_Location_Map_Item = {
                vendor_source_id: location.vendor_source_id,
                vendor_source_location_id: location.id,
            };

            locations.push(locationDetail);
        }

        return locations;
    };

    updateCategory = (category: ICategory, options?: { discounts?: number[] }) => {
        const payload: IUpdateCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: category.guid,
            name: category.name,
            note: category.note,
            email: category.email,
        };

        if (category.Vendor_Source_Locations) {
            payload.vendor_source_locations = this.processLocations(category.Vendor_Source_Locations);
        }

        if (this.props.supplierModel.has_discounts) {
            payload.discounts = options?.discounts || [];
        }

        if (this.props.supplierModel.has_price_group_category_discounts && category.price_group_discount) {
            payload.price_group_discount = category.price_group_discount;
        }

        if (this.props.supplierModel.has_category_discounts && !_.isNil(category.discount)) {
            payload.discount = category.discount;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesUpdateCategory, payload);
    };

    onCreateCategory = (data: IOnCreateCategoryDTO) => {
        this.setState(
            {
                allowAddCategory: true,
            },
            () => {
                this.getCategories();
            }
        );
    };

    onUpdateCategory = (data: IOnUpdateCategoryDTO) => {
        const notification: INotification = {
            message: "successfully_updated_category",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                allowAddCategory: true,
            },
            () => {
                this.getCategories();
            }
        );
    };

    reorderCategories = (oldIndex: number, newIndex: number) => {
        // oldIndex/newIndex are positions within the saved (guid-bearing) siblings;
        // map them back to positions in the full list before moving
        const savedGuids = this.state.categories.filter((category) => category.guid).map((category) => category.guid);
        const fromIndex = this.state.categories.findIndex((category) => category.guid === savedGuids[oldIndex]);
        const toIndex = this.state.categories.findIndex((category) => category.guid === savedGuids[newIndex]);

        if (fromIndex === -1 || toIndex === -1) {
            return;
        }

        this.reorderSnapshot = [...this.state.categories];

        const categories = arrayMove([...this.state.categories], fromIndex, toIndex);

        this.setState({ categories }, () => {
            const payload: IReorderCategoriesDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                categoryGuids: categories.filter((category) => category.guid).map((category) => category.guid),
            };

            if (this.props.catalogModel) {
                payload.catalogGuid = this.props.catalogModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.CategoriesReorderCategories, payload);
        });
    };

    onReorderCategories = (data: IOnReorderCategoriesDTO) => {
        // Sibling groups are disjoint, so one guid match means this group is ours
        const ownGuids = new Set(this.state.categories.map((category) => category.guid));

        if (!data.categories.length || !data.categories.some((category) => ownGuids.has(category.guid))) {
            return;
        }

        this.reorderSnapshot = null;

        const orderByGuid = new Map(data.categories.map((category) => [category.guid, category.category_order]));

        // Keep the optimistic display order; only reconcile category_order values
        const categories = this.state.categories.map((category) =>
            orderByGuid.has(category.guid) ? { ...category, category_order: orderByGuid.get(category.guid) } : category
        );

        this.setState({ categories });
    };

    notify = (data: IErrorDTO) => {
        // The global Notify handler in App.tsx already shows the error toast
        if (data?.message === "ERROR_REORDERING_CATEGORIES" && this.reorderSnapshot) {
            this.setState({ categories: this.reorderSnapshot });
            this.reorderSnapshot = null;
        }
    };

    onDeleteCategory = (data: IOnDeleteCategoryDTO) => {
        this.setState(
            {
                allowAddCategory: true,
                categories: [],
            },
            () => {
                this.getCategories();
            }
        );
    };

    render() {
        const categoryGuids = this.state.categories.filter((category) => category.guid).map((category) => category.guid);
        const hasUnsavedCategory = _.some(this.state.categories, (category) => !category.guid);

        const categoriesList = _.map(this.state.categories, (category, index) => {
            const accordion = (
                <CategoryAccordion
                    key={category.guid}
                    category={category}
                    createCategoryFn={this.createCategory}
                    updateCategoryFn={this.updateCategory}
                    cancelCategoryFn={this.cancelCategory}
                    socket={this.props.socket}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    catalogModel={this.props.catalogModel}
                    priceGroups={this.props.priceGroups}
                    level={1}
                    isSimpleCategories={this.props.isSimpleCategories}
                    vendorSources={this.state.vendorSources}
                    homeCategory={category.is_home_category}
                    notifyFn={this.props.notifyFn}
                    index={index}
                />
            );

            if (!category.guid) {
                return accordion;
            }

            return (
                <SortableCategoryItem key={category.guid} guid={category.guid}>
                    {accordion}
                </SortableCategoryItem>
            );
        });

        return (
            <div className="sidebar CategorySidebar p-3 position-relative">
                <div className={"header"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <div className={"d-flex flex-row w-100 align-items-center"}>
                        <OwTitle
                            leftIconName={"fad fa-layer-group"}
                            title={this.props.isHomeCategories ? "home_categories" : "categories"}
                        />
                        <div className={"ms-2"}>
                            <OwButton
                                disabled={!this.state.allowAddCategory}
                                fn={this.addCategory}
                                title={"add"}
                                leftIconClass={"far fa-plus"}
                            />
                        </div>
                    </div>
                    <hr />
                </div>
                <div className={"content CategoryForm pb-2 "}>
                    <div className={"mb-2"}>
                        <SortableCategoryList
                            itemGuids={categoryGuids}
                            disabled={hasUnsavedCategory || categoryGuids.length < 2}
                            onReorder={this.reorderCategories}>
                            {categoriesList}
                        </SortableCategoryList>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategorySidebar;
